import React from 'react';
import {connect} from "react-redux";
import l10n from "../../l10n/localization";
import Loader from "../common/Loader";
import validation from '../../validation/commodity';
import Validate from 'validate.js';
import * as utilsCommon from "../../utils/utils";
import CWForm from "./CWForm";
import * as utils from "../../utils/commodity";
import * as commodityActions from "../../actions/commodity";
import SelectCommodityGroups from "./fields/SelectCommodityGroups";
import * as commodityGroupActions from "../../actions/commodityGroup";

class CommodityForm extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            item: utilsCommon.notNullNorUndefined(this.props.item) ? this.props.item.item : null,
            schema: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        title: l10n.commodities.name,
                    },
                    commodityGroup: {
                        type: "string",
                        title: l10n.commodities.commodityGroupName,
                        openDrawer: this.props.openDrawer
                    },
                }
            },
            uiSchema: {
                name: {
                    "ui:emptyValue": ""
                },
                commodityGroup: {
                    "ui:field": "selectCommodityGroup",
                },
            },
            fields: {
                selectCommodityGroup: SelectCommodityGroups,
            },
            isDirty: false,
            formData: utils.commodityToForm(utilsCommon.notNullNorUndefined(this.props.item) ? this.props.item.item : null)
        }
    }

    componentDidMount() {
        this.props.dispatch(commodityGroupActions.fetchCommodityGroups(true));
    }

    onSubmit = ({formData}) => {
        let form = Object.assign({}, {...formData});

        if (utilsCommon.notNullNorUndefined(this.state.item) && (utilsCommon.notNullNorUndefined(this.state.item.id) || utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement)) {
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    form.id = this.props.newlyCreatedElement;
                    this.props.dispatch(commodityActions.edit(form));
                })
            } else {
                this.setState({item: formData}, () => {
                    this.props.dispatch(commodityActions.edit(form));
                })
            }
        } else {
            this.setState({item: formData}, () => {
                this.props.dispatch(commodityActions.add(form));
            })
        }
        this.setState((state) => {return {...state, isDirty: false,formData: formData};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    handleChange = (formData) => {
        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    handleError = () => {
        this.props.dispatch(commodityActions.errorMessage(l10n.validation.form_error));
    };

    render() {
        let formClassName = (this.state.isDirty) ? 'commodity-form dirty':'commodity-form';

        if (this.props.loading || this.props.saving) {
            return (<div><Loader /></div>)
        }

        return (
            <div className={formClassName}>
                <h1>Commodity</h1>
                <CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.state.formData}
                    showErrorList={false}
                    validate={this.validate}
                    liveValidate={true}
                    onSubmit={this.onSubmit}
                    onError={this.handleError}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    fields={this.state.fields} >
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.commodity.loading,
        saving: state.commodity.saving,

        newlyCreatedElement: state.creation.newlyCreatedCommodity,
    });
})(CommodityForm);



// WEBPACK FOOTER //
// ./src/components/forms/CommodityForm.js